<template>
  <div class="bg-light border" ontouchmove="return false" :style="'height:' + height +'; width:' + width + '; border-color: #efefef'">
    <div class="signature-canvas-container position-relative">
      <canvas ref="canvas" class="signature-canvas"></canvas>
      <small class="position-absolute text-muted"  style="bottom: 0.2em; left: 0.4em">
        {{ $t('Sign here') }}
      </small>
      <button type="button"
              :class="[
          'btn btn-sm btn-link text-danger position-absolute',
          !hasSignature ? 'd-none' : ''
        ]" style="bottom: 0.2em; right: 0.2em" v-on:click.prevent="onClickEraser">
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";
import SignaturePad from 'signature_pad';
const props = defineProps({
  imageUrl: {
    default: null,
  },
  height: {
    default: '200px',
  },
  width: {
    default: '100%',
  }
});

const signPad = ref(null);
const cachedWidth = ref(null)
const hasSignature = ref(false)

const emits = defineEmits([
  'input',
])


const onClickEraser = () => {
  resetSignature()
  emits('input', null)
}
const resetSignature = () => {
  if(signPad.value) {
    signPad.value.clear();
    hasSignature.value = false;
  }
}
defineExpose({
  resetSignature,
})


const canvas = ref(null)
const resizeCanvas = () => {
  if(canvas.value.offsetWidth !== cachedWidth.value) { //add
    cachedWidth.value = canvas.offsetWidth;   //add

    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.value.width = canvas.value.offsetWidth * ratio;
    canvas.value.height = canvas.value.offsetHeight * ratio;
    const ctx = canvas.value.getContext("2d");
    ctx.scale(ratio, ratio);
  }
}

onMounted(() => {
  console.log('mounted SignaturePad')
  resizeCanvas();

  signPad.value = new SignaturePad(canvas.value, {
    onEnd: function() {
      hasSignature.value = !this.isEmpty();
      console.log('SignaturePad onEnd', this.isEmpty(), this.toDataURL())
      if(!this.isEmpty()) {
        emits('input', this.toDataURL())
      }
    }
  });
})
</script>

<style scoped>
  .signature-canvas-container{
    height: 100%;
  }
  .signature-canvas{
    height: 100%;
    width: 100%;
    margin: 0 auto;
    border: 3px solid #FFFFFF;
  }
</style>